import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load dashboard layout
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));

// Lazy load dashboard pages
const DashboardPage = lazy(() => import('@/pages/dashboard'));
const OspDashboardPage = lazy(() => import('@/pages/dashboard/osp'));
const ActivitiesPage = lazy(() => import('@/pages/activities'));
const CheckInPage = lazy(() => import('@/pages/check-in'));
const GigsPage = lazy(() => import('@/pages/gigs'));
const ImportPage = lazy(() => import('@/pages/import'));
const JobSpecForecastPage = lazy(() => import('@/pages/jobSpecForecast'));
const MediaPage = lazy(() => import('@/pages/media'));
const NotificationsPage = lazy(() => import('@/pages/notifications'));
const ReadinessForecastPage = lazy(() => import('@/pages/readinessForecast'));
const RestorationsPage = lazy(() => import('@/pages/restorations'));
const RevenueReportPage = lazy(() => import('@/pages/revenue-report'));
const SessionsPage = lazy(() => import('@/pages/sessions'));

/**
 * Dashboard route group
 * Contains all main dashboard routes with the dashboard layout
 */
export const dashboardRoutes: RouteConfig = {
  path: '/dashboard',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      element: DashboardPage,
    },
    {
      path: '/osp',
      element: OspDashboardPage,
    },
  ],
};

/**
 * Other top-level dashboard routes
 * These use the dashboard layout but are at the root level
 */
export const activitiesRoutes: RouteConfig = {
  path: '/activities',
  layout: DashboardLayout,
  element: ActivitiesPage,
};

export const checkInRoutes: RouteConfig = {
  path: '/check-in',
  layout: DashboardLayout,
  children: [{ path: '', element: CheckInPage }],
};

export const gigsRoutes: RouteConfig = {
  path: '/gigs',
  layout: DashboardLayout,
  element: GigsPage,
};

export const importRoutes: RouteConfig = {
  path: '/import',
  layout: DashboardLayout,
  element: ImportPage,
};

export const jobSpecForecastRoutes: RouteConfig = {
  path: '/jobSpecForecast',
  layout: DashboardLayout,
  element: JobSpecForecastPage,
};

export const mediaRoutes: RouteConfig = {
  path: '/media',
  layout: DashboardLayout,
  element: MediaPage,
};

export const notificationsRoutes: RouteConfig = {
  path: '/notifications',
  layout: DashboardLayout,
  element: NotificationsPage,
};

export const readinessForecastRoutes: RouteConfig = {
  path: '/readinessForecast',
  layout: DashboardLayout,
  element: ReadinessForecastPage,
};

export const restorationsRoutes: RouteConfig = {
  path: '/restorations',
  layout: DashboardLayout,
  element: RestorationsPage,
};

export const revenueReportRoutes: RouteConfig = {
  path: '/revenue-report',
  layout: DashboardLayout,
  element: RevenueReportPage,
};

export const sessionsRoutes: RouteConfig = {
  path: '/sessions',
  layout: DashboardLayout,
  element: SessionsPage,
};
